import React from 'react';
import { ArrowRight, ChevronRight } from 'lucide-react';
import { categoryOf } from '../../config/serviceCategories';
import { ServiceIcon } from '../services/ServiceIcon';

/**
 * One WP3 service the user may use: code, category, name, description and
 * the Business Cases that grant it. On phones it collapses to a compact row.
 * `businessCaseNames` maps a Business Case code to its full name (tooltip).
 */
export const ServiceCard = ({ service, businessCaseNames = {}, onOpen }) => {
  const category = categoryOf(service.categoryKey);
  const proposed = service.access?.status === 'proposed';
  const businessCases = service.access?.businessCases || [];

  return (
    <button
      type="button"
      onClick={onOpen}
      className="card-base w-full text-left p-4 flex flex-col gap-2.5 bg-white border-0 hover:shadow-card-hover focus-ring"
      aria-label={`Open ${service.name}`}
    >
      <span className="w-full flex items-center gap-2.5">
        <ServiceIcon categoryKey={service.categoryKey} />
        <span className="text-[11px] font-medium text-lb-muted tracking-[0.02em]">
          {service.code} · {category.title}
        </span>
        {proposed && (
          <span
            className="ml-auto text-[10.5px] font-semibold px-2 py-[2px] rounded-full"
            style={{ background: '#FBEBCF', color: '#8a5a1a' }}
            title="Proposed for your role; not yet confirmed in the Business Case"
          >
            Proposed
          </span>
        )}
        <ChevronRight size={16} className={`${proposed ? '' : 'ml-auto'} text-lb-muted md:hidden`} aria-hidden="true" />
      </span>
      <span className="block text-[14px] font-semibold text-lb-ink-strong leading-[1.35]">{service.name}</span>
      {service.description && (
        <span className="text-[12.5px] text-lb-muted leading-[1.5] line-clamp-2 max-md:hidden">{service.description}</span>
      )}
      <span className="w-full mt-auto pt-1 flex items-center justify-between gap-2 max-md:hidden">
        <span className="flex flex-wrap gap-1">
          {businessCases.map((code) => (
            <span
              key={code}
              title={businessCaseNames[code]}
              className="text-[11px] font-medium px-1.5 py-[1px] rounded-[4px] bg-black/[0.05] text-lb-muted"
            >
              {code}
            </span>
          ))}
        </span>
        <span className="inline-flex items-center gap-1 text-[12.5px] font-medium text-lb-green-primary">
          Open <ArrowRight size={13} aria-hidden="true" />
        </span>
      </span>
    </button>
  );
};
